module.exports = __webpack_public_path__ + "static/media/ErrorAltClose.75e0cb5b.svg";